import { motion } from "framer-motion";

const BioStrip = () => (
  <section data-testid="bio-strip" className="relative mx-auto w-full max-w-2xl px-6 py-8 md:py-12">
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.2, ease: "easeOut" }}
    >
      <div aria-hidden="true" className="mb-10 h-px w-16 bg-[#d4af37]/40 md:mb-14" />
      <p className="dropcap font-serif-display text-xl font-light leading-relaxed text-[#f3ead6]/80 md:text-2xl md:leading-relaxed">
        Amrita Sen is an artist, performer, musician and visual artist. Her
        BollyDoll universe — first launched through Art Basel in 2011 — tells
        the music-filled story of two princess sisters, Rani and Sheena, in a
        world inspired by her mother's artwork. What began as art prints has
        grown into objects for everyday life, while her practice moves between
        music, film, television and design.
      </p>
    </motion.div>
  </section>
);

export default BioStrip;
